import apiClient from "./axios";

const BASE = "/v1/settlement/revision";

export const settlementRevisionApi = {
    voidInvoiceWithReparse: (idsId, reason, mode = "reparse") =>
        apiClient.post(`${BASE}/invoices/${idsId}/void-with-reparse`, { reason, mode }),

    commitWithReplace: (newIdsId) =>
        apiClient.post(`${BASE}/invoices/${newIdsId}/commit-with-replace`, {}),

    assessImpact: (targetId, targetType) =>
        apiClient.get(`${BASE}/assess-impact`, {
            params: {
                target_id: targetId,
                target_type: targetType,
            },
        }),
};

export default settlementRevisionApi;
